import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Receipt, Download, CreditCard } from "lucide-react";
import { toast } from "sonner";

export default function CompanyInvoices() {
  const [items, setItems] = useState([]);
  const refresh = () => api.get("/payments/invoices").then(r => setItems(r.data || [])).catch(() => {});
  useEffect(() => { refresh(); }, []);
  const payInvoice = async (inv) => {
    try {
      const r = await api.post("/payments/checkout", { invoice_id: inv.id, amount: inv.amount });
      toast.success("Sessione di pagamento (mock) creata");
      // Confirm immediately (mock)
      await api.post(`/payments/${r.data.payment_id}/confirm`);
      toast.success("Pagamento completato");
      refresh();
    } catch (e) { toast.error("Errore pagamento"); }
  };
  return (
    <div>
      <h1 className="font-display text-2xl font-bold text-slate-900 mb-1">Fatture e pagamenti</h1>
      <p className="text-sm text-slate-600 mb-6">Stripe in modalità test - i pagamenti sono simulati.</p>
      <div className="cxo-card overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-xs uppercase tracking-wider text-slate-500">
            <tr>
              <th className="p-3 text-left">Numero</th>
              <th className="p-3 text-left">Data</th>
              <th className="p-3 text-right">Importo</th>
              <th className="p-3 text-left">Stato</th>
              <th className="p-3 text-right">Azioni</th>
            </tr>
          </thead>
          <tbody>
            {items.map(inv => (
              <tr key={inv.id} className="border-t border-slate-100">
                <td className="p-3 font-medium text-slate-900">{inv.number}</td>
                <td className="p-3 cxo-tabular">{inv.issue_date}</td>
                <td className="p-3 cxo-tabular text-right font-semibold">€{(inv.amount || 0).toLocaleString('it-IT')}</td>
                <td className="p-3"><Badge className={`border-0 ${inv.status === "paid" ? "bg-[#E9F8F1] text-[#1F9D6A]" : inv.status === "pending" ? "bg-amber-100 text-amber-700" : "bg-red-100 text-red-700"}`}>{inv.status}</Badge></td>
                <td className="p-3 text-right">
                  {inv.status === "pending" && <Button size="sm" onClick={() => payInvoice(inv)} className="bg-[#2D6BFF] text-white"><CreditCard size={14} className="mr-1" /> Paga (test)</Button>}
                </td>
              </tr>
            ))}
            {!items.length && <tr><td colSpan={5} className="p-10 text-center text-slate-500">Nessuna fattura</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
